import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

export const PublicRoute = ({
  isAuthenticated,
  isVerified,
  component: Component,
  asGuest,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        isVerified ? (
          <Redirect to="/" />
        ) : (
          <Redirect to="/verify_email" />
        )
      ) : (
        <Component {...props} asGuest={asGuest} />
      )
    }
  />
);

const mapStateToProps = state => ({
  isAuthenticated: !!state.auth.uid,
  isVerified: !!state.auth.is_verified
});

export default connect(mapStateToProps)(PublicRoute);
